import type { ReactNode } from 'react';
import { useBlocker } from '@tanstack/react-router';
import { DiscardChangesDialog } from '@/components/common/DiscardChangesDialog';

export function useConfirmBeforeLeave(hasUnsavedChanges: boolean): ReactNode {
  const blocker = useBlocker({
    shouldBlockFn: ({ current, next }) => current.pathname !== next.pathname,
    enableBeforeUnload: hasUnsavedChanges,
    disabled: !hasUnsavedChanges,
    withResolver: true,
  });

  function handleDialogOpenChange(nextOpen: boolean) {
    if (!nextOpen) blocker.reset?.();
  }

  return (
    <DiscardChangesDialog
      open={blocker.status === 'blocked'}
      onOpenChange={handleDialogOpenChange}
      onDiscard={() => blocker.proceed?.()}
    />
  );
}
